<template>
	<div v-if="bracket && bracket.length">
		<h2 class="subtitle has-text-centered" v-if="heading">{{ heading }}</h2>

		<!-- TABLET+ BRACKET VIEW -->
		<div class="bracket is-hidden-mobile is-tiered" :class="`bracket-${bracket[0].matchups.length * 2}`">
			<BracketRound v-for="(round, index) in bracket" :round="round" :addonClass="`bracket-round-${index + 1}`" />
		</div>

		<!-- MOBILE BRACKET VIEW -->
		<nav class="is-hidden-tablet pagination pagination-dots" role="navigation" aria-label="navigation">
			<ul class="pagination-list">
				<li>
					<a
						v-for="(round, index) in bracket"
						class="pagination-link"
						:class="{ 'is-current': activeRound == index }"
						@click="setRound(index)"
						>Round {{ index + 1 }}</a
					>
				</li>
			</ul>
		</nav>

		<v-touch
			@swiperight="prevRound"
			@swipeleft="nextRound"
			:swipe-options="{ direction: 'horizontal' }"
			class="bracket is-hidden-tablet slider"
			:data-num-matchups="bracket[0].matchups.length"
		>
			<BracketRound
				v-for="(round, index) in bracket"
				:round="round"
				:addonClass="{ 'is-prev': index < activeRound, 'is-active': index == activeRound, 'is-next': index > activeRound }"
			/>
		</v-touch>
	</div>
</template>

<script>
import BracketRound from "./BracketRound"

export default {
	components: {
		BracketRound,
	},
	props: {
		heading: {
			type: String,
			default: null,
		},
		bracket: {
			type: Array,
			default: () => null,
		},
		is_playoffs: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		activeRound() {
			return this.is_playoffs
				? this.$store.getters.activePagePlayoffsBracketRound
				: this.$store.getters.activePageConsolationBracketRound
		},
		canNextRound() {
			return this.activeRound + 1 < this.bracket.length
		},
		canPrevRound() {
			return this.activeRound > 0
		},
	},
	methods: {
		nextRound() {
			this.setRound(this.activeRound + 1)
		},
		prevRound() {
			this.setRound(this.activeRound - 1)
		},
		setRound(round) {
			if (round >= 0 && round < this.bracket.length) {
				if (this.is_playoffs) {
					this.$store.dispatch("setActivePagePlayoffsBracketRound", round)
				} else {
					this.$store.dispatch("setActivePageConsolationBracketRound", round)
				}
			}
		},
	},
}
</script>

<style lang="scss">
/*
.bracket {
	display: flex;
	justify-content: center;
	overflow-x: auto;
	padding-bottom: 3rem;
}

.round {
	flex: 1;
	max-width: 20rem;
	min-width: 15rem;
}

.matchup { position: relative; }
.matchup.is-bye { visibility: hidden; }

.description {
	left: 50%;
	position: absolute;
	transform: translate(-50%, 0);
}

$border_width: 0.2rem;
$line_height: 1.5rem; // see body's font size and line height for this rule

.team {
	border-bottom: $border_width solid #CCCCCC;
	display: flex;
	justify-content: space-between;
	padding-left: 0.5rem;
	padding-right: 2rem;

	&.team-2 { border-right: $border_width solid #CCCCCC; }
	&.team-winner {
		left: 100%;
		position: absolute;
		width: 100%;
	}

	.name { flex: 1 }
}

$round1_padding_top: 0;
$round1_team_padding_top: 3rem;
$round1_team_height: $line_height + $round1_team_padding_top + $border_width;

.round-1 { padding-top: $round1_padding_top; }
.round-1 .team { padding-top: $round1_team_padding_top; }
.round-1 .matchup:first-child .team-1 { padding-top: 0; }
.round-1 .description, .round-1 .team-winner { bottom: $round1_team_height / 2; }

$round2_padding_top: $round1_padding_top + $round1_team_height / 2;
$round2_team_padding_top: $round1_team_height * 2 - $line_height - $border_width;
$round2_team_height: $line_height + $border_width + $round2_team_padding_top;

.round-2 { padding-top: $round2_padding_top; }
.round-2 .team { padding-top: $round2_team_padding_top; }
.round-2 .matchup:first-child .team-1 { padding-top: 0; }
.round-2 .description, .round-2 .team-winner { bottom: $round2_team_height / 2; }

$round3_padding_top: $round2_padding_top + $round2_team_height / 2;
$round3_team_padding_top: $round2_team_height * 2 - $line_height - $border_width;
$round3_team_height: $line_height + $border_width + $round3_team_padding_top;

.round-3 { padding-top: $round3_padding_top; }
.round-3 .team { padding-top: $round3_team_padding_top; }
.round-3 .matchup:first-child .team-1 { padding-top: 0; }
.round-3 .description, .round-3 .team-winner { bottom: $round3_team_height / 2; }

// don't have any better ideas...
.bracket-8 .round-2 .matchup.is-loser:last-child { margin-top: $round2_team_height * 1.5; }
.bracket-8 .round-2 .matchup.is-loser .team-1 { padding-top: $round1_team_padding_top; }
.bracket-8 .round-2 .matchup.is-loser .team-2 { padding-top: $round1_team_padding_top; }
.bracket-8 .round-2 .matchup.is-loser .description, .bracket-8 .round-2 .matchup.is-loser .team-winner { bottom: $round1_team_height / 2; }

.bracket-8 .round-3 .matchup.is-loser .team-1 { padding-top: $round2_team_padding_top; }
.bracket-8 .round-3 .matchup.is-loser .team-2 { padding-top: $round2_team_padding_top; }
.bracket-8 .round-3 .matchup.is-loser .description, .bracket-8 .round-3 .matchup.is-loser .team-winner { bottom: $round2_team_height / 2; }
*/

/*
TODO:

desktop bracket
- solve alignment of losers matchhes
- make alignment more predictable than the css that is hard-coded
*/

$matchup_description_height: 1rem + (5rem / 16rem);

$matchup_team_padding_x: 0.5rem;
$matchup_team_padding_y: 0.75rem;
$matchup_team_height: 1rem + $matchup_team_padding_y * 2;
$matchup_height: $matchup_team_height * 2;
$matchup_spacing: 2rem;
$matchup_total_height: $matchup_description_height + $matchup_height;

$round_padding: 1rem;

.bracket.is-tiered {
	display: flex;
	justify-content: center;
	margin-left: -1rem;
	margin-right: -1rem;
}

.bracket.is-tiered .bracket-round {
	flex: 1;
	max-width: 33%;
	padding: 1rem;
}

.bracket.is-tiered .is-repeat-heading {
	visibility: hidden;
}

.bracket .teams {
	background: #ffffff;
	border: 1px solid rgba(0, 0, 0, 0.05);
	border-radius: 5px;
	box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.05);
	height: $matchup_height;
}

.bracket .bracket-matchup {
	margin-bottom: $matchup_spacing;
}

.bracket.is-tiered .bracket-round-2 .bracket-matchup:first-child {
	margin-top: $matchup_total_height + $matchup_spacing - $matchup_description_height - $matchup_team_height;
}

.bracket.is-tiered.bracket-8 .bracket-round-2 .bracket-matchup {
	margin-bottom: $matchup_total_height + $matchup_spacing * 2;
}

.bracket.is-tiered .bracket-round-3 .bracket-matchup:first-child {
	margin-top: $matchup_total_height + $matchup_spacing - $matchup_description_height - $matchup_team_height + $matchup_total_height +
		$matchup_spacing;
}

.bracket.is-tiered .bracket-round-3 .bracket-matchup {
	margin-bottom: $matchup_total_height + $matchup_spacing * 2;
}

.bracket .teams > .team {
	align-items: center;
	display: flex;
	height: $matchup_team_height;
	justify-content: space-between;
	padding: $matchup_team_padding_y $matchup_team_padding_x;
}

.bracket .teams > .team + .team {
	border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.slider {
	overflow: hidden;
	position: relative;
	width: 100%;
}

@for $i from 1 to 20 {
	.slider[data-num-matchups="#{$i}"] {
		height: $i * $matchup_total_height + $i * $matchup_spacing + $round_padding * 2;
	}
}

.slider > * {
	padding: $round_padding;
	position: absolute;
	left: 0;
	top: 0;
	transition: transform 0.4s ease-in-out;
	width: 100%;
}

.slider > .is-prev {
	transform: translateX(-100%);
}
.slider > .is-next {
	transform: translateX(100%);
}
</style>
